import { render, staticRenderFns } from "./discreteSliderManyItem.vue?vue&type=template&id=0701ebd1"
import script from "./discreteSliderManyItem.vue?vue&type=script&lang=js"
export * from "./discreteSliderManyItem.vue?vue&type=script&lang=js"
import style0 from "./discreteSliderManyItem.vue?vue&type=style&index=0&id=0701ebd1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports